/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useEffect, useState } from 'react';
import Carousel from '@brainhubeu/react-carousel';
import { Card, Grid } from '@mui/material';

import '@brainhubeu/react-carousel/lib/style.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../assets/styles/components/darlings';

import { ReactComponent as IconDarlings } from '../../assets/images/svg/shops/icon_queridinhos.svg';
import { ReactComponent as IconPlus } from '../../assets/images/svg/shops/icon_mais.svg';

import { ItypeReturnApi } from '../../helpers/utils/TypeReturnApi';
import { api } from '../../services';
import { FormatPrice } from '../../helpers/utils/Formating';

const Darlings: React.FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();

  const [dataDarlings, setDataDarlings] = useState<any>();
  const [dataLocation, setDataLocation] = useState<any>();

  const handleToPage = (url: string) => {
    return navigate(url);
  };

  const handleListDarlings = async () => {
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.shop.indexPromotions({
          nr_operacao: 48,
          idMarketplace: dataLocation.idMarketplace,
        });
      setDataDarlings(result.data);
    } catch (error) {
      toast.error('Ocorreu um erro ao buscar os queridinhos.');
    }
  };

  const handleSelectDarlings = (data: any) => {
    handleToPage(
      `shop/detail/list/product/subcategorie/${window.btoa(
        data.idRestaurante,
      )}/${window.btoa(data.idCardapio)}/${window.btoa(
        data.idCategoria,
      )}/${window.btoa(data.idSubCategoria)}`,
    );
  };

  useEffect(() => {
    if (dataLocation?.idMarketplace) {
      handleListDarlings();
    }
  }, [dataLocation]);

  useEffect(() => {
    const dataStorage = JSON.parse(
      localStorage.getItem('@mais/delivery/dataStateCity') as string,
    );
    if (dataStorage?.idMarketplace) {
      setDataLocation(dataStorage);
    }
  }, []);

  return (
    <>
      {dataDarlings?.length > 0 && (
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          padding="10px"
          className="darlings"
        >
          <Grid className={classeStyle.girdTitle}>
            <IconDarlings />
            <p className={classeStyle.textTitle}>Queridinhos</p>
          </Grid>
          <Carousel
            slidesPerPage={1}
            arrows
            itemWidth={110}
            animationSpeed={150}
            breakpoints={{
              360: {
                itemWidth: 110,
                slidesPerPage: 1,
                arrows: false,
              },
              640: {
                itemWidth: 115,
                slidesPerPage: 1,
                arrows: false,
              },
              900: {
                slidesPerPage: 1,
                arrows: true,
              },
            }}
          >
            {dataDarlings.map((item: any) => (
              <Card
                key={item.idItem}
                onClick={() => handleSelectDarlings(item)}
                className={classeStyle.cardDarlings}
              >
                <p className={classeStyle.textTitleDarlings}>
                  {item.dsNome.substring(0, 24)}
                </p>
                <img
                  className={classeStyle.imgDarlings}
                  src={`${process.env.REACT_APP_API_IMG}${item.dsImagem}`}
                  alt="Banner"
                />
                <Grid className={classeStyle.gridValue}>
                  <IconPlus className={classeStyle.iconPlusValue} />
                  <p className={classeStyle.textTitleDarlingsValue}>
                    R$ {FormatPrice(item.vlItem)}
                  </p>
                </Grid>
              </Card>
            ))}
          </Carousel>
        </Grid>
      )}
    </>
  );
};
export default Darlings;
